import { Resource } from 'src_common/common/mobx-utils/Resource';
import { ProviderGameType, CollectionType, ProviderType } from 'src/domains/casino/models/models';

export class ProviderGamesModel {
    public constructor(
        private readonly resource: Resource<Array<ProviderGameType> | null>,
        public readonly provider: ProviderType
    ) {}

    private get allGames(): Array<ProviderGameType> | 'loading' {
        const data = this.resource.get();

        if (data.type === 'loading') {
            return 'loading';
        }

        if (data.type === 'ready' && data.value !== null) {
            return data.value;
        }

        return [];
    }

    public getCollectionGames(collection: CollectionType): Array<ProviderGameType> | 'loading' {
        if (this.allGames === 'loading') {
            return 'loading';
        }

        return this.allGames.filter((game) => game.collection === collection || game.collection === undefined);
    }
}
